import type React from 'react';

import type { IconProps } from 'types/icon';

const ChevronLeft: React.FC<IconProps> = ({
  size = '20',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M15.9956 5.58706C15.746 5.33752 15.3416 5.33752 15.092 5.58706L8.40005 12.2785L15.0915 18.9763C15.3409 19.226 15.7459 19.2263 15.9956 18.9769C16.2451 18.7276 16.2453 18.3231 15.9961 18.0734L10.2077 12.2791L15.9956 6.49058C16.2451 6.24103 16.2451 5.83661 15.9956 5.58706Z"
        fill={color}
      />
    </svg>
  );
};

export default ChevronLeft;
